/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

export var Globals = {};

export var Status = {
  CONNECTED: 1,
  DISCONNECTED: 2,
};

export var Protocol = {
  PING: "2",
  LOGIN: "61",
  LOGOUT: "62",
  USER_SETTINGS: "59",
  USER_SETTINGS_RESPONCE: "60",
  ERROR: "90",
  GAME_STATE: "63",
  BET: "64",
  BET_INFO: "65",
  BET_INFO_ALL: "66",
  HISTORY: "67",
  HISTORY_END: "68",
  GET_JACKPOT: "69",
  JACKPOT_INFO: "70",
  JACKPOT_WIN: "71",
  SUBSCRIBE: "72",
  SET_SEED: "101",
  FIRST_DEAL: "102",
  FIRST_DEAL_RESPONCE: "103",
  NEXT_STEP: "104",
  NEXT_STEP_RESPONCE: "105",
  RESET: "106",
  RESET_RESPONCE: "107",
  DOUBLE_UP: "108",
  DOUBLE_UP_RESPONCE: "109",
  TAKE: "110",
  TAKE_RESPONCE: "111",
  DOUBLE_UP_ANSWER: "112",

  DOUBLE_UP_ANSWER_RESPONCE: "113",
  WIN_STATS: "114",
  WIN_STATS_RESPONCE: "115",
  GET_ROUND: "116",
  GET_ROUND_RESPONCE: "117",

  GET_SEEDS: "118",
  GET_SEEDS_RESPONCE: "119",

  GET_STATS: "120",
  GET_STATS_RESPONCE: "121",

  END_MESSAGE: "\r\n",
  DELIMETER: ",",
};

export var ListType = {
  ALL: "ALL",
  MY: "MY",
  HIGH: "HIGH",
};

export var EventType = {
  ALL: "ALL",
  BUTTON_CLICKED: "BUTTON_CLICKED",
  DU_BUTTON_CLICKED: "DU_BUTTON_CLICKED",
};

export var ErrorTypes = {
  CONCURRENT_CONNECTION: "1",
  INVALID_SESSION: "2",
  INSUFFICIENT_FUNDS: "3",
  INVALID_BET_AMOUNT: "4",
  INVALID_BET: "6",
  PF_NOT_SET: "7",
  CLIENT_SEED_ERROR: "8",
  CLIENT_SEED_OK: "9",
  SYSTEM_ERROR: "10",
};

export var WinTypes = [
  { coef: 0, name: "" },
  { coef: 0, name: "JACKS OR BETTER" },
  { coef: 0, name: "TWO PAIR" },
  { coef: 0, name: "3 OF A KIND" },
  { coef: 0, name: "STRAIGHT" },
  { coef: 0, name: "FLUSH" },
  { coef: 0, name: "FULL HOUSE" },
  { coef: 0, name: "4 OF A KIND" },
  { coef: 0, name: "STRAIGHT FLUSH" },
  { coef: 0, name: "ROYAL FLUSH" },
];
